import {Editor} from "slate";
import isHotkey from 'is-hotkey'
import {KeyboardEvent} from "react";

export type EditorWithHotkeys = {
    onKeyDown: (e: KeyboardEvent<HTMLDivElement>) => void
}

const withHotkeys = (editor: Editor): Editor => {
    editor.onKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
        switch (true) {
            case isHotkey('mod+b', e):
                e.preventDefault()
                editor.toggleBold();
                break;
            case isHotkey('mod+i', e):
                e.preventDefault()
                editor.toggleItalic();
                break;
            case isHotkey('mod+u', e):
                e.preventDefault()
                editor.toggleUnderline();
                break;
        }
    }

    return editor
}

export default withHotkeys
